module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_8011.03261797.png";